module.exports = __webpack_public_path__ + "img/get.79809ba7.png";